
import React, { useEffect, useRef } from 'react';


export function IndexBanner() {
	const ref = useRef(null);

	if (typeof window !== 'undefined') {

	}

	useEffect(() => {
		if (!ref.current) return;
		const el = ref.current;
		console.log('IndexBanner: element client size', el.clientWidth, el.clientHeight);
		console.log('IndexBanner: bounding rect', el.getBoundingClientRect());
		const cs = window.getComputedStyle(el);
		console.log('IndexBanner: computed styles', {
			backgroundImage: cs.backgroundImage,
			backgroundSize: cs.backgroundSize,
			backgroundPosition: cs.backgroundPosition,
			backgroundRepeat: cs.backgroundRepeat,
			zIndex: cs.zIndex,
			display: cs.display,
			visibility: cs.visibility,
			opacity: cs.opacity
		});

		// log ancestors background/colors to detect overlays
		let node = el.parentElement;
		while (node) {
			const ncs = window.getComputedStyle(node);
			console.log('Ancestor', node.tagName, node.className, {
				bg: ncs.backgroundColor,
				z: ncs.zIndex,
				pos: ncs.position,
				overflow: ncs.overflow
			});
			node = node.parentElement;
		}
	}, []);

	return (
		<div
			ref={ref}
			className="index-banner-container"
			style={{
				position: 'relative',
				width: '100%',
				aspectRatio: '16/6', // Proporción panorámica
				maxHeight: '420px', // Altura máxima aumentada
				minHeight: '220px', // Altura mínima aumentada
				height: '100%',
				overflow: 'hidden',
			}}
		>
			<video
				src={require('../../video/UNIEMPLEO-Animation_1.mp4')}
				style={{
					width: '100%',
					height: '100%',
					objectFit: 'cover',
					objectPosition: 'center',
					display: 'block',
					// sin bordes redondeados
				}}
				autoPlay
				loop
				muted
				playsInline
				controls={false}
			/>
		</div>
	);
}